import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import logo from './logo_af7_blue.svg';
import VerticalLinearStepper from './components/VerticalLinearStepper';
import './App.css';

import { ApolloProvider } from 'react-apollo'
import client from './apolloClient'
import { createMuiTheme } from 'material-ui/styles';

const defaultTheme = createMuiTheme();


class App extends Component {
  render() {
    return (
      <ApolloProvider client={client}>
      <MuiThemeProvider theme={defaultTheme}>
        <div className="App">
          <header className="App-header">
            <img src={logo} className="App-logo" alt="logo" />
            <h1 className="App-title">Registro en AF7</h1>
            <p>v 2019.1.1</p>
          </header>
          <VerticalLinearStepper />
        </div>
      </MuiThemeProvider>
      </ApolloProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js